import { Box, Button, List, ListItem, Stack, Typography } from '@mui/material';
import React, { CSSProperties } from 'react';
import { certifyAlertAction } from 'src/redux/actions/monthEndAlertsAction';
import { useDispatch, useSelector } from 'react-redux';
import { getMonthRange } from 'src/utils/getMonthRange';
import useCurrentUser from 'src/hooks/use-current-user';

type Props = {
  close: any;
  getMonthEndAlertData: any;
};

function CertifyModal(props: Props) {
  const { close } = props;
  const dispatch = useDispatch();
  const [providerId] = useCurrentUser(['providerId'])
  const facilityId = localStorage.getItem('facilityId') || '';
  const getCertifyResponse = useSelector((state: any) => state.certifyMonthEndAlertReducer);

  const modalStyle: CSSProperties = {
    position: 'fixed',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    WebkitTransform: 'translate(-50%, -50%)',
  };
  const modalContainerStyle: CSSProperties = {
    backgroundColor: '#fff',
    width: 'auto',
    height: 'auto',
    paddingBottom: '24px',
  };

  const certifyPoints = [
    'The therapy services were billed accurately to reflect the services provided to each patient and are in compliance with federal and state regulations, including but not limited to, Medicare, Medicaid, private insurance guidelines.',
    'To confirm that the documentation supports the medical necessity of the therapy services provided including diagnoses, goals, progress notes, and treatment plans',
    'Any changes or updates to therapy services have been properly documented and authorized.',
    'All labor has been logged, reviewed, and approved.',
  ];

  const certifyMonthEndAlert = () => {
    const getFirstMonthDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const getLastMonthDay = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    const requestBody = {
      facilityUuid: facilityId,
      signedByUuid: providerId,
      status: 'COMPLETED',
      startDate: getMonthRange(getFirstMonthDay),
      endDate: getMonthRange(getLastMonthDay),
    };
    dispatch(certifyAlertAction(requestBody));
  };

  return (
    <>
      <Box style={modalStyle}>
        <Box style={modalContainerStyle}>
          <Stack>
            <Box sx={{ padding: '24px 24px 24px 24px' }}>
              <Typography variant="customHeading">Month End Alert Certification</Typography>
            </Box>
          </Stack>
          <Stack
            spacing={3}
            sx={{ padding: '24px 24px 24px 24px' }}
          >
            <Typography>
              I hereby certify that I have reviewed all therapy billing charges and labor logged
              within our electronic medical record (EMR) system:
            </Typography>
            <List>
              {certifyPoints.map((item: string, index: number) => {
                return (
                  <ListItem
                    sx={{ display: 'list-item', listStyleType: 'disc', marginLeft: '20px' }}
                    key={index}
                  >
                    {item}
                  </ListItem>
                );
              })}
            </List>
          </Stack>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              marginRight: '24px',
            }}
          >
            <Box sx={{ flexGrow: 1 }} />
            <Button
              color="inherit"
              onClick={close}
            >
              Cancel
            </Button>
            <Button
              sx={{ ml: 1 }}
              type="submit"
              variant="contained"
              onClick={certifyMonthEndAlert}
              disabled={getCertifyResponse?.loading}
            >
              Certify
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default CertifyModal;
